"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRowEffectivelySelected = exports.getParentId = exports.getHeaderCheckboxState = exports.getChildrenSelectionState = exports.getAllDescendants = exports.getAllAncestors = void 0;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Utility functions for handling hierarchical selection logic
 */

/**
 * Get parent ID from row data, supporting both parentReference and parentId structures
 */
var getParentId = exports.getParentId = function getParentId(row) {
  var _row$parentReference;
  return ((_row$parentReference = row.parentReference) === null || _row$parentReference === void 0 ? void 0 : _row$parentReference.id) || row.parentId;
};

/**
 * Get all descendant IDs for a given parent ID
 */
var _getAllDescendants = exports.getAllDescendants = function getAllDescendants(parentId, allRows) {
  if (!allRows) return [];
  var children = allRows.filter(function (row) {
    return getParentId(row) === parentId;
  });
  return children.reduce(function (acc, child) {
    return [].concat(_toConsumableArray(acc), [child.id], _toConsumableArray(_getAllDescendants(child.id, allRows)));
  }, []);
};

/**
 * Get all ancestor IDs for a given child ID
 */
var _getAllAncestors = exports.getAllAncestors = function getAllAncestors(childId, allRows) {
  if (!allRows) return [];
  var child = allRows.find(function (row) {
    return row.id === childId;
  });
  if (!child) return [];
  var parentId = getParentId(child);
  if (!parentId) return [];
  return [parentId].concat(_toConsumableArray(_getAllAncestors(parentId, allRows)));
};

/**
 * Check if a row is effectively selected based on selection state and inheritance
 */
var isRowEffectivelySelected = exports.isRowEffectivelySelected = function isRowEffectivelySelected(rowId, selectedRowIds, explicitlyDeselectedIds, allRows) {
  // Row is explicitly deselected
  if (explicitlyDeselectedIds.has(rowId)) return false;

  // Row is directly selected
  if (selectedRowIds.has(rowId)) return true;

  // Check if any ancestor is selected (and this row is not explicitly deselected)
  var ancestors = _getAllAncestors(rowId, allRows);
  return ancestors.some(function (ancestorId) {
    return selectedRowIds.has(ancestorId) && !explicitlyDeselectedIds.has(rowId);
  });
};

/**
 * Get the selection state of children for a given parent (recursively considers all descendants)
 */
var getChildrenSelectionState = exports.getChildrenSelectionState = function getChildrenSelectionState(parentId, allRows, selectedRowIds, explicitlyDeselectedIds) {
  if (!allRows) return {
    allSelected: false,
    someSelected: false,
    noneSelected: true
  };
  var children = allRows.filter(function (child) {
    return getParentId(child) === parentId;
  });
  if (children.length === 0) return {
    allSelected: false,
    someSelected: false,
    noneSelected: true
  };
  var totalDescendants = 0;
  var selectedDescendants = 0;

  // Recursively count all descendants and their selection state
  var _countDescendantsRecursively = function countDescendantsRecursively(nodeId) {
    var directChildren = allRows.filter(function (child) {
      return getParentId(child) === nodeId;
    });
    var _iterator = _createForOfIteratorHelper(directChildren),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var child = _step.value;
        totalDescendants++;
        var isSelected = isRowEffectivelySelected(child.id, selectedRowIds, explicitlyDeselectedIds, allRows);
        if (isSelected) {
          selectedDescendants++;
        }

        // Recursively count this child's descendants
        _countDescendantsRecursively(child.id);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
  _countDescendantsRecursively(parentId);
  return {
    allSelected: totalDescendants > 0 && selectedDescendants === totalDescendants,
    someSelected: selectedDescendants > 0,
    noneSelected: selectedDescendants === 0
  };
};

/**
 * Calculate header checkbox state based on visible rows
 */
var getHeaderCheckboxState = exports.getHeaderCheckboxState = function getHeaderCheckboxState(rows, selectedRowIds, explicitlyDeselectedIds, allRows) {
  if (!rows || rows.length === 0) {
    return {
      checked: false,
      indeterminate: false
    };
  }
  var selectedVisibleRows = rows.filter(function (row) {
    return isRowEffectivelySelected(row.id, selectedRowIds, explicitlyDeselectedIds, allRows);
  });

  // Check if any visible row has descendants selected (even if not visible)
  var hasIndeterminateRows = rows.some(function (row) {
    if (isRowEffectivelySelected(row.id, selectedRowIds, explicitlyDeselectedIds, allRows)) return false; // Already selected

    // Check if this row has any selected descendants in allRows
    var descendants = _getAllDescendants(row.id, allRows);
    return descendants.some(function (descendantId) {
      return isRowEffectivelySelected(descendantId, selectedRowIds, explicitlyDeselectedIds, allRows);
    });
  });
  var totalAffectedRows = selectedVisibleRows.length + (hasIndeterminateRows ? 1 : 0);
  if (totalAffectedRows === 0) {
    return {
      checked: false,
      indeterminate: false
    };
  } else if (selectedVisibleRows.length === rows.length && !hasIndeterminateRows) {
    return {
      checked: true,
      indeterminate: false
    };
  } else {
    return {
      checked: false,
      indeterminate: true
    };
  }
};